import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VehicleMake, VehicleModel } from '../models/vehicle.model';
import { MOCK_VEHICLE_MAKES, MOCK_VEHICLE_MODELS, getYears } from '../data/mock-vehicles';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  private makes = MOCK_VEHICLE_MAKES;
  private models = MOCK_VEHICLE_MODELS;

  constructor() { }

  /**
   * Obtém todas as marcas de veículos
   */
  getVehicleMakes(): Observable<VehicleMake[]> {
    return of([...this.makes].sort((a, b) => a.nome.localeCompare(b.nome)));
  }

  /**
   * Obtém modelos por marca
   */
  getVehicleModels(makeId: string): Observable<VehicleModel[]> {
    const models = this.models
      .filter(m => m.makeId === makeId)
      .sort((a, b) => a.nome.localeCompare(b.nome));
    return of(models);
  }

  /**
   * Obtém anos disponíveis
   */
  getYears(): Observable<number[]> {
    return of(getYears());
  }

  /**
   * Obtém nome da marca por ID
   */
  getMakeName(makeId: string): string {
    const make = this.makes.find(m => m.id === makeId);
    return make ? make.nome : '';
  }

  /**
   * Obtém nome do modelo por ID
   */
  getModelName(modelId: string): string {
    const model = this.models.find(m => m.id === modelId);
    return model ? model.nome : '';
  }
}

